<header class="{{_sharedService.isMobile() ? 'mobile-header' : ''}}">
  <div class="d-flex align-items-center" style="padding-right: 30px;">

    <img src="assets/logo.svg" title="TotalEnergies" alt="TotalEnergies" class="logo pointer" [routerLink]="'/price-list'"/>
    <div class="d-flex flex-column w-100">
      <div class="d-flex flex-row align-items-center" style="margin-top: 12px;">
        <div class="app-title" style="margin-left: 2rem;">{{"app-title" | translate}}</div>
        <ng-container *ngIf="(_userService.getUser() | async) && user?.workspaces?.length > 1">
          <button [matMenuTriggerFor]="account" class="ms-auto quartery-btn" mat-raised-button (click)="workspaceExpanded = !workspaceExpanded">
            
            <span>{{userService.getCurrentWorkspace() ? userService.getCurrentWorkspace().label : ''}}</span>
            <div class="icon-override arrow-{{workspaceExpanded ? 'top' : 'down'}}-icon size-20" style="margin-left: 12px"></div>
          </button>
          <mat-menu class="mt-2" #account="matMenu" [overlapTrigger]="false" (closed)="workspaceExpanded = !workspaceExpanded">
            <button mat-menu-item class="pr-5" *ngFor="let workspace of user.workspaces" (click)="userService.changeCurrentWorkspace(workspace)">{{ workspace.label }}</button>
          </mat-menu>
        </ng-container>
        <ng-container *ngIf="(_userService.getUser() | async) && user?.workspaces?.length == 1">
          <button class="ms-auto quartery-btn-no-hover" mat-raised-button>
            <span>{{userService.getCurrentWorkspace() ? userService.getCurrentWorkspace().label : ''}}</span>  
          </button>
        </ng-container>
        <ng-container *ngIf="_userService.getUser() | async">
          <button [matMenuTriggerFor]="account" class="{{user?.workspaces?.length > 0 ? 'ms-4' : 'ms-auto'}} quartery-btn" mat-raised-button (click)="expand()">
            <span>{{_userService.getUser().getValue().first_name + ' ' + _userService.getUser().getValue().last_name.slice(0, 1)}}.</span>
            <div class="icon-override arrow-{{expanded ? 'top' : 'down'}}-icon size-20" style="margin-left: 12px"></div>
          </button>
          <mat-menu class="mt-2" #account="matMenu" [overlapTrigger]="false" (closed)="expand()">
            <button mat-menu-item routerLink="/auth/logout">Logout</button>
          </mat-menu>
        </ng-container>
      </div>
      <hr class="w-100" style="margin-left: 2rem;">
      <div class="d-flex align-items-center">
        <div class="nav-bar">
          <app-navigation *ngIf="_userService.getUser() | async"></app-navigation>
        </div>
        <!-- <mat-select class="lang ms-auto" #langSelect [(ngModel)]="selectedLang" (selectionChange)="updateLang($event.value)" style="width: 5em">
          <mat-option *ngFor="let lang of languages" [value]="lang.value">
            {{ lang.value | uppercase }}
          </mat-option>
        </mat-select> -->
      </div>
      
    </div>
  </div>
</header>